// src/client/hooks/usePwaUpdate.ts
// Thin wrapper over vite-plugin-pwa's virtual register module.
// Returns { needRefresh, update } so callers do not import from the virtual
// module directly (easier to mock in tests and keeps the virtual import
// isolated to one place).
import { useRegisterSW } from 'virtual:pwa-register/react';

export interface PwaUpdateState {
  /** True when a new service worker is waiting to activate. */
  needRefresh: boolean;
  /** Call to skip waiting and reload the page with the new SW. */
  update: () => void;
}

export function usePwaUpdate(): PwaUpdateState {
  const { needRefresh: [needRefresh], updateServiceWorker } = useRegisterSW();
  return {
    needRefresh: needRefresh ?? false,
    update: () => { void updateServiceWorker(true); },
  };
}
